import { ContentStep, ContentType, OnboardingStep } from "@/types/onbaording.types";
import { FileText, BookOpen, Layout } from "lucide-react";

export const contentTypes: ContentType[] = [
  {
    id: "blog",
    name: "Blog Posts",
    description: "Regular informative articles to educate your audience and boost SEO.",
    icon: FileText,
    iconProps: "w-5 h-5 text-primary",
    recommended: "Recommended for SEO 🔍",
  },
  {
    id: "guide",
    name: "How-to Guides",
    description: "Step-by-step instructions in your helpful, clear format.",
    icon: BookOpen,
    iconProps: "w-5 h-5 text-primary",
    recommended: "Great for User Experience 🎯",
  },
  {
    id: "landing",
    name: "Landing pages",
    description: "Convert visitors with compelling value propositions.",
    icon: Layout,
    iconProps: "w-5 h-5 text-primary",
    recommended: "Best for Conversions 💎",
  },
];

export const contentSteps: ContentStep[] = [
  {
    id: 1,
    name: "Account setup",
    description: "Creating your workspace",
    detail: "Setting up your personal account and workspace",
    duration: 1000,
    substeps: ["Creating workspace", "Setting up account"],
  },
  {
    id: 2,
    name: "Reading website",
    description: "Analyzing your website",
    detail: "Extracting and analyzing your website content",
    duration: 3000,
    substeps: ["Fetching sitemap", "Reading pages", "Analyzing content"],
  },
  {
    id: 3,
    name: "Language detection",
    description: "Identifying website language",
    detail: "Detecting the primary language of your content",
    duration: 1500,
    substeps: ["Analyzing HTML", "Processing text", "Identifying language"],
  },
  {
    id: 4,
    name: "Learning tone of voice",
    description: "Understanding your style",
    detail: "Learning how you sound to match your voice",
    duration: 2500,
    substeps: [
      "Identifying key pages",
      "Analyzing writing style",
      "Capturing brand voice",
    ],
  },
  {
    id: 5,
    name: "Reading key content",
    description: "Analyzing important pages",
    detail: "Reading your most important content in depth",
    duration: 2000,
    substeps: ["Extracting content", "Processing structure", "Identifying themes"],
  },
  {
    id: 6,
    name: "Suggesting content ideas",
    description: "Creating content ideas",
    detail: "Generating content ideas based on your site",
    duration: 2500,
    substeps: ["Analyzing opportunities", "Generating topics", "Matching to audience"],
  },
];

export const steps: OnboardingStep[] = [
  {
    id: 1,
    name: "Account setup",
    description: "Creating your workspace",
  },
  {
    id: 2,
    name: "Reading website",
    description: "Analyzing your website",
  },
  {
    id: 3,
    name: "Language detection",
    description: "Identifying website language",
  },
  {
    id: 4,
    name: "Learning tone-of-voice",
    description: "Understanding your style",
  },
  {
    id: 5,
    name: "Reading key content",
    description: "Analyzing important pages",
  },
  {
    id: 6,
    name: "Suggesting content ideas",
    description: "Creating content ideas",
  },
];

export const INTEGRATION_OPTIONS = [
  {
    id: "cms",
    label: "Could we publish content?",
    options: [
      { id: "wordpress", label: "WordPress" },
      { id: "other_cms", label: "Other CMS" },
    ],
  },
  {
    id: "some",
    label: "Would you like to share on social media?",
    options: [
      { id: "facebook", label: "Facebook" },
      { id: "twitter", label: "Twitter/X" },
      { id: "linkedin", label: "LinkedIn" },
      { id: "instagram", label: "Instagram" },
    ],
  },
  {
    id: "crm",
    label: "Do you use a CRM or email platform?",
    options: [
      { id: "mailchimp", label: "Mailchimp" },
      { id: "activecampaign", label: "ActiveCampaign" },
      { id: "hubspot", label: "HubSpot" },
      { id: "salesforce", label: "Salesforce" },
      { id: "other_crm", label: "Other CRM" },
    ],
  },
  {
    id: "analytics",
    label: "Would you like to connect analytics?",
    options: [
      { id: "google_search_console", label: "Google Search Console" },
      { id: "other_analytics", label: "Other Analytics" },
    ],
  },
];

// Chat-specific onboarding steps
export const chatSteps: OnboardingStep[] = [
  { id: 1, name: 'Account setup', description: 'Creating your workspace' },
  { id: 2, name: 'Reading website', description: 'Analyzing your website' },
  { id: 3, name: 'Language detection', description: 'Identifying website language' },
  { id: 4, name: 'Learning tone-of-voice', description: 'Understanding your style' },
  { id: 5, name: 'Reading key content', description: 'Analyzing important pages' }
];

// Settings names for after analysis is complete
export const settingsSteps: OnboardingStep[] = [
  { id: 1, name: 'Workspace', description: 'Your content workspace' },
  { id: 2, name: 'Website structure', description: 'Pages and content analysis' },
  { id: 3, name: 'Language settings', description: 'Content language configuration' },
  { id: 4, name: 'Tone & style', description: 'Your writing voice' },
  { id: 5, name: 'Key content', description: 'Important pages and topics' }
];
